import { useState } from 'react';
import { Redirect, RouteComponentProps, Router } from '@reach/router';
import { PolicyStreamWelcomePage } from './PolicyStreamWelcomePage';
import { PolicyStreamWhitelabel } from './PolicyStreamWhitelabel';
import { PolicyStreamQuizPage } from './PolicyStreamQuizPage';
import { PolicyStreamPlanSelectionPage } from './PolicyStreamPlanSelectionPage';
import { PolicyStreamPlanSpecificQuestionsPage } from './PolicyStreamPlanSpecificQuestions';
import { PolicyStreamDonePage } from './PolicyStreamDonePage';
import { PolicyStreamBaseInformationPage } from './PolicyStreamBaseInformationPage';
import { policyStreamPaths } from './policyStreamConstants';
import { PolicyStreamErrorsModal } from './PolicyStreamErrorsModal';
import { PolicyStreamResume } from './PolicyStreamResume/PolicyStreamResume';
import { PolicyStreamRecommendationsDisplayPage } from './PolicyStreamRecommendationsDisplayPage';
import { PolicyStreamEmailSavePage } from './PolicyStreamEmailSavePage';
import { PolicyStreamNotFoundPage } from './components/PolicyStream404/PolicyStreamNotFoundPage';
import { PolicyStreamReviewPage } from './PolicyStreamReviewPage';
import { PolicyStreamProvider } from './InPolicyStream';
import { PolicyStreamPostPlanSelectionInformationPage } from './PolicyStreamPostPlanSelectionInformationPage';
import { useSettings } from '../../hooks';
import { PolicyStreamInvalidInsuranceTypePage } from './components/PolicyStreamInvalidInsuranceTypePage';
import PolicyStreamHamburgerMenu from './PolicystreamHamburgerMenu';
import { PolicyStreamTos } from './PolicyStreamTos';
import { PolicyStreamDemo } from './PolicyStreamDemo';

interface PolicyStreamProps extends RouteComponentProps {}

export const PolicyStream = (_props: PolicyStreamProps) => {
  const { ready, settings } = useSettings();
  const [open, setOpen] = useState<boolean>(false);

  if (ready && !settings.types.includes('LIFE')) {
    if (
      settings.types.length === 0 ||
      settings.types.includes('PERSONAL') ||
      settings.types.includes('COMMERCIAL')
    ) {
      return <Redirect to='/insurtech/quote' />;
    } else {
      // NB no one should ever see this, but it's here as a backup
      return <PolicyStreamInvalidInsuranceTypePage />;
    }
  }
  return (
    <PolicyStreamProvider>
      <PolicyStreamWhitelabel onOpenSidebar={() => setOpen(true)}>
        <Router>
          <PolicyStreamResume path={`${policyStreamPaths.resume.slug}/:uuid`} />
          <PolicyStreamWelcomePage
            path={policyStreamPaths.welcome.slug || '/'}
          />
          <PolicyStreamBaseInformationPage
            path={policyStreamPaths.baseInformation.slug}
          />
          <PolicyStreamQuizPage path={policyStreamPaths.personalize.slug} />
          <PolicyStreamEmailSavePage path={policyStreamPaths.emailSave.slug} />
          <PolicyStreamRecommendationsDisplayPage
            path={policyStreamPaths.recommendations.slug}
          />
          <PolicyStreamPlanSelectionPage
            path={policyStreamPaths.planSelection.slug}
          />
          <PolicyStreamPostPlanSelectionInformationPage
            path={policyStreamPaths.postPlanSelectionInformation.slug}
          />
          {/* 
DEPRECATED: we don't use this anymore. Maybe delete the component after a while? 2025-07-18
<PolicyStreamContactInfoPage 
path={policyStreamPaths['contactInfo'].slug} 
/> */}
          <PolicyStreamPlanSpecificQuestionsPage
            path={policyStreamPaths['planSpecificQuestions'].slug}
          />
          <PolicyStreamReviewPage path={policyStreamPaths.review.slug} />
          <PolicyStreamDonePage path={policyStreamPaths.done.slug} />
          <PolicyStreamTos path={policyStreamPaths.tos.slug} />
          <PolicyStreamDemo path={policyStreamPaths.demo.slug} />
          <PolicyStreamNotFoundPage path='*' />
        </Router>
        <PolicyStreamErrorsModal />
      </PolicyStreamWhitelabel>
      <PolicyStreamHamburgerMenu
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
      />
    </PolicyStreamProvider>
  );
};
